import angular, { IScope } from 'angular';
import { TODO } from '@b2b/types/core/utils';

RemoveSecondaryContactModalController.$inject = [
  '$scope', 
  '$uibModalInstance', 
  'contact'
];

function RemoveSecondaryContactModalController(
  $scope: IScope & { removeSecondaryContactModal: TODO }, 
  $uibModalInstance: TODO, 
  contact: TODO
) {
  const ctrl = {
    model: {},

    init: function () {
      ctrl.model = contact;
    },

    done: function () {
      $uibModalInstance.close(ctrl.model);
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },
  };

  $scope.removeSecondaryContactModal = ctrl;
  ctrl.init();
}

export const RemoveSecondaryContactModalModule = angular
  .module('acme.view.application.partners.create.removeSecondaryContactModal.controllers', [])
  .controller('RemoveSecondaryContactModalController', RemoveSecondaryContactModalController).name;
